export default function removeAllSlides() {
  const swiper = this;
  const slidesIndexes = [];

  for (let i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}


//////////////////
// WEBPACK FOOTER
// /Users/jpaq/Local Sites/metsfarsa/app/public/wp-content/themes/farsa/node_modules/swiper/modules/manipulation/methods/removeAllSlides.js
// module id = 101
// module chunks = 0